import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createCommunicationIntentsSlice } from './actions';
import { CommunicationIntentsStore } from './types';
import { ZustandStores } from '../../utils';
import { createIndexedDBStorage } from '../../utils/indexedDBAdapter';

export const useCommunicationIntentsStore = create<CommunicationIntentsStore>()(
  persist(
    (set, get, store) => ({
      ...createCommunicationIntentsSlice(set, get, store),
    }),
    {
      name: ZustandStores.USER_COMMUNICATION_INTENTS,
      storage: createJSONStorage(() => createIndexedDBStorage()),
      partialize: (state) => ({ intents: state.intents }),
      onRehydrateStorage: () => (state) => {
        // A survived intent may already be stale by the time IndexedDB
        // resolves; drop it here so a hydration race can't resurrect an
        // expired correction.
        state?.pruneExpiredIntents();
      },
    },
  ),
);
